<div class="modal-content">
    <div class="modal-header row">
        <h5 class="col-4 modal-title" id="exampleModalLabel">Mapa de Hotéis</h5>
        <!-- <app-typeahead class="" [lista]="referenciasPesquisada" [searchText]="referenciaPesquisada.display_field"
            (searchFunction)="buscaRefenciaDebounce($event)" (selectItem)="selecionouReferencia($event)">
            <input autocomplete="off" class="form-control" placeholder="Pontos de Referencia do Mapa"
                (ngModelChange)="buscaRefenciaDebounce($event)" [(ngModel)]="referenciaPesquisada.display_field"
                name="buscaDadosMapa" />
        </app-typeahead> -->
    </div>
    <div class="modal-body mt-3">
        <mgl-map [center]="[lng == undefined ? 0 : lng, lat == undefined ? 0 : lat]"
            [style]="'mapbox://styles/mapbox/streets-v11'" [zoom]="[zoom]" [minZoom]="minZoom" (mapCreate)="map = $event"
            (mapWheel)="onMapInteraction();"  (move)="onMapInteraction()" (mapLoad)="onMapInteraction()">
            <mgl-control mglFullscreen position="top-right"></mgl-control>
            <mgl-control mglScale unit="metric" position="top-right"></mgl-control>
            <mgl-control mglNavigation [showCompass]="true" [showZoom]="true" position="top-right"></mgl-control>

            <ng-container *ngFor="let hotel of mapHoteis; let i = index">
                <mgl-marker (dragStart)="ngOnDestroy()" [lngLat]="[hotel.Longitude, hotel.Latitude]" [anchor]="posicaoDoMapa(hotel.Latitude, hotel.Longitude)" #myMarker>
                    <div class="row d-flex justify-content-center btn-primary" style="border-radius: 16px;">
                        <div class="col-12 text-center"
                            style="color: #F0F0F0;margin: 6px 12px; font-size: 12px; font-weight: 500;">
                            <i class="fas fa-bed"></i>
                            <!-- Apartir de {{hotel.SiglaMoeda}} {{hotel.ValorMinimo | currency : 'BRl' : '' : '1.2-2'}} -->
                            <!-- {{hotel.Nome}} -->
                        </div>
                    </div>
                </mgl-marker>
                <mgl-popup (dragStart)="ngOnDestroy()" [marker]="myMarker" style="width: 100%; max-width: 280px;" [anchor]="posicaoDoMapa(hotel.Latitude, hotel.Longitude)">
                    <div class="row font-popup">
                        <img [src]="hotel.Imagem" alt="Hotel sem Imagem" class="text-muted"
                            style="width: 100%; max-height: 80px;">
                        <div class="col-12">
                            <p class="mt-1 mb-0" style="font-weight: 600;">{{hotel.Nome}}</p>
                            <div class="">
                                <estrela [estrela]="hotel.QuantidadeEstrelas"></estrela> {{hotel.Pensoes}}
                            </div>
                            <p class="mt-1 mb-0" style="font-size: 12px; line-height: 12px;">{{hotel.Endereco}}</p>
                        </div>
                        <div class="col-12 d-flex justify-content-start" *ngIf="busca?.usuario.EmpresaId != null">
                            <p><b>Fornecedor:</b> {{hotel.Fornecedor}}</p>
                        </div>
                        <div class="col-12 d-flex justify-content-start">
                            <p><b>Valor:</b><br /> Apartir de {{hotel.SiglaMoeda}} {{hotel.ValorMinimo | currency :
                                'BRl' : '' : '1.2-2'}}
                            </p>
                        </div>
                        <div class="col-12">
                            <button class="btn btn-secondary w-100"
                                (click)="levarAoHotel(hotel.CodigoFornecedor, modalHotel)">Selecionar Hotel</button>
                        </div>
                    </div>
                </mgl-popup>
            </ng-container>
        </mgl-map>
    </div>
</div>

<ng-template let-modal #modalHotel>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{refHotel.Nome}}</h5>
        <button type="button" class="close btn" aria-label="Close" (click)="fecharModalHotel()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="refHotel.AgrupamentoFornecedor?.length>1" style="border-bottom: 1px solid #CFCFCF;">
            <button *ngFor="let agrupador of refHotel.AgrupamentoFornecedor; let k = index"
                class="btn btn-success btn-round btn-sm"
                style="margin-right: 5px !important;margin-top: 5px !important;margin-bottom: 5px !important;"
                (click)="trocarHotelFornecedor(agrupador,refHotel)">{{(busca.usuario.EmpresaId !=
                null?agrupador.Fornecedor:k+1)}}</button>
        </div>
        <app-hotel [indexHotel]="0" [hotel]="refHotel" (selecionouHotel)="selecionoHotel($event)" [usuario]="busca.usuario"
            (removeuHotel)="removeuHotel($event)"></app-hotel>
    </div>
</ng-template>